import { Button, Form, Input, Space, Typography } from "antd";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import { AuthContext } from "../../useAuth";

const { useForm } = Form;

/*
	BillingType: "PerRegistrant",
	Limit: 10,
	RegistrantCount: 0,
	RegistrationDeadline: "2023-01-23T19:19:57.134Z",
	RequireShipping: false,
	Cost: 250,
*/
const ClassRegistration = ({ course }) => {
  const {
    BillingType,
    Limit,
    RegistrantCount,
    RegistrationDeadline,
    RequireShipping,
    Cost,
    StartTime,
  } = course;

  let now = dayjs(),
    deadline = dayjs(RegistrationDeadline || StartTime);

  let price = BillingType === "PerRegistrant" ? Cost : null;

  const registrationOpen = now < deadline && RegistrantCount < Limit;

  return (
    <>
      <Typography.Title level={5} style={{ textAlign: "center" }}>
        {course?.Name}
      </Typography.Title>
      {registrationOpen && <ClassCheckout {...course} />}
    </>
  );
};

const ClassCheckout = ({ CourseId, Cost, RequireShipping, StartTime }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { user } = useContext(AuthContext);

  // Build registration form steps
  let steps = [
    {
      key: 1,
      render: () => <ClassReservation cost={Cost} startTime={StartTime} />,
    },
  ];
  if (RequireShipping) steps.push({ key: 2, render: () => <ClassAddress /> });
  steps.push({ key: "review", render: () => <ReservationReview /> });
  steps.push({ key: 4, render: () => <ClassRegistrationComplete /> });

  const [form] = useForm();

  const next = () => {
    let v = form.validateFields().then(() => {
      currentStep !== steps.length - 1 && setCurrentStep(currentStep + 1);
      currentStep === steps.length - 1 && submit();
    });
  };

  const prev = () => {
    currentStep !== 0 && setCurrentStep(currentStep - 1);
  };

  const submit = () => {
    const { Street, City, Zip, State } = form.getFieldsValue(true);
    const payload = {
      UserId: user?.UserId,
      CourseId: CourseId,
      OrganizationId: user?.OrganizationId,
      Paid: true,
    };

    payload.Address = { Street: Street, City: City, State: State, Zip: Zip };
    console.log(payload);
  };

  return (
    <>
      <Form form={form} layout="vertical">
        <ClassRegistrationStep>
          {steps[currentStep].render()}
        </ClassRegistrationStep>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button onClick={() => next()} block size="large">
            Reserve Your Seat
          </Button>
          {currentStep > 0 && (
            <Button onClick={() => prev()} type="text" block>
              Go Back
            </Button>
          )}
        </Space>
      </Form>
    </>
  );
};

const ClassRegistrationStep = ({ children }) => {
  return <div className="class-registration-step">{children}</div>;
};

const ClassReservation = ({ cost, startTime }) => {
  let startsIn = dayjs(startTime).fromNow();
  return <>{startsIn}</>;
};

const ClassAddress = () => {
  return (
    <>
      <Typography.Paragraph type="secondary">
        This class has materials that will be shipped to you.
      </Typography.Paragraph>
      <Form.Item name="Street" label="Street" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="City" label="City" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="State" label="State" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="Zip" label="Zip Code" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
    </>
  );
};

const ClassPayment = () => {
  return <>Payment section</>;
};

const ReservationReview = () => {
  return <>Review</>;
};

const ClassRegistrationComplete = () => {
  return <>Complete!</>;
};

export default ClassRegistration;
